<template>
	<section v-if="section" :class="{ 'text-color-white': isDarkTheme }">
		<div class="container">
			<StrategyShowcase
				v-for="(strategy, s) in section.strategies"
				:key="s"
				:strategy="strategy"
				:is-dark-theme="isDarkTheme"
				:class="{ bt: s !== 0 || showFirstElementTopBorder }"
			/>

			<div
				v-if="section.sectionDisclaimer"
				class="body-xs text-align-center"
				:class="isDarkTheme ? 'muted' : 'text-color-content-tertiary'"
			>
				<div v-for="(paragraph, i) in section.sectionDisclaimer" :key="i" v-html="paragraph" />
			</div>
		</div>
	</section>
</template>
<script setup lang="ts">
import { StrategiesSection } from 'types/real-estate-strategy';
import StrategyShowcase from '@components/marketing-site/strategy-showcase.vue';
interface Props {
	section: StrategiesSection;
	isDarkTheme?: boolean;
	showFirstElementTopBorder?: boolean;
}
withDefaults(defineProps<Props>(), {
	isDarkTheme: true,
	showFirstElementTopBorder: false
});
</script>
